import { useEffect, useState } from "react";

export function useIsDesktop(breakpoint = 720) {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth > breakpoint : true,
  );
  useEffect(() => {
    const f = () => setIsDesktop(window.innerWidth > breakpoint);
    window.addEventListener("resize", f);
    return () => window.removeEventListener("resize", f);
  }, [breakpoint]);
  return isDesktop;
}
